const MAX_LOG_SIZE = 500
const logs = []

window.addEventListener('unhandledrejection', event => {
  logs.push(['', event.reason])
  if (logs.length > MAX_LOG_SIZE) logs.shift()
})

// const originalConsoleInfo = console.info
// const originalConsoleWarn = console.warn
// const originalConsoleError = console.error

// console.info = function (...args) {
//   logs.push(['info', ...args])
//   if (logs.length > MAX_LOG_SIZE) logs.shift()
//   originalConsoleInfo.apply(console, args)
// }

// console.warn = function (...args) {
//   logs.push(['warn', ...args])
//   if (logs.length > MAX_LOG_SIZE) logs.shift()
//   originalConsoleWarn.apply(console, args)
// }

// console.error = function (...args) {
//   logs.push(['error', ...args])
//   if (logs.length > MAX_LOG_SIZE) logs.shift()
//   originalConsoleError.apply(console, args)
// }

export const extractLog = () => logs.splice(0, 20)
